<template lang="html">
  <content-block @remove="deleteBlock()" :fresh="block.edit" @edit="editBlock()" @input="saveChanges()" :controls="controls">
    <div class="content_block__text">
      <div class="content_block__line"></div>
    </div>
  </content-block>
</template>

<script>
  import ContentBlock from './ContentBlock'

export default {
  components: {
    ContentBlock
  },
  name: "ContentBlockLine",
  props: {
    block: {
      type: Object,
    },
    controls: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      edit: false
    }
  },
  mounted () {
    if (this.controls) {
      this.edit = this.block.edit || false;
    }
  },
  methods: {
    editBlock () {
      this.edit = true;
    },
    deleteBlock () {
      this.$emit('remove')
    },
    saveChanges() {
      this.edit = false;
      this.$emit('input', this.block)
    }
  }
}
</script>
